import React, { Component } from 'react';
import { Button, Input, message, Tag, Space } from 'antd';
import { CopyOutlined, CrownOutlined, UserOutlined } from '@ant-design/icons';
import styles from './style.less';
import { post } from '../../../commons/http';

export default class TeamManage extends Component {
  state = {
    team: null,
    isCaptain: false,
    inviteCode: '',
    loading: false,
    joinLoading: false,
  };

  componentDidMount() {
    this.fetchMyTeam();
  }

  fetchMyTeam = async (notifyParent) => {
    const { competitionId } = this.props;
    const response = await post('/competition/getMyTeam', { competitionId });
    if (response.code === 0) {
      this.setState({
        team: response.data.team,
        isCaptain: response.data.isCaptain,
      });
      // 把 teamId / isCaptain 回传给父组件（用于取消报名）
      if (notifyParent && this.props.onSignUp) {
        this.props.onSignUp({
          teamId: response.data.team?._id,
          isCaptain: response.data.isCaptain,
        });
      }
    }
  };

  createTeam = async () => {
    const { competitionId, onSignUp } = this.props;
    this.setState({ loading: true });
    const response = await post('/competition/createTeam', { competitionId });
    this.setState({ loading: false });
    if (response.code === 0) {
      message.success('队伍创建成功，邀请码已生成', 1.5);
      this.fetchMyTeam(true);
    } else {
      message.error(response.msg || '创建失败，请稍后重试', 2);
      // 如果其实已经报名了，刷新一次
      if (response.msg && response.msg.indexOf('已报名') > -1) {
        this.fetchMyTeam(true);
      }
    }
  };

  joinTeam = async () => {
    const { competitionId, onSignUp } = this.props;
    const code = this.state.inviteCode.trim().toUpperCase();
    if (!code) {
      message.warning('请输入邀请码', 1);
      return;
    }
    this.setState({ joinLoading: true });
    const response = await post('/competition/joinTeam', {
      competitionId,
      inviteCode: code,
    });
    this.setState({ joinLoading: false });
    if (response.code === 0) {
      message.success('加入队伍成功', 1.5);
      this.fetchMyTeam(true);
    } else {
      message.error(response.msg || '加入失败，请稍后重试', 2);
    }
  };

  copyInvite = () => {
    const { team } = this.state;
    if (!team || !team.inviteCode) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(team.inviteCode)
        .then(() => message.success('邀请码已复制', 1))
        .catch(() => message.error('复制失败，请手动复制', 1));
    } else {
      message.info('邀请码：' + team.inviteCode, 2);
    }
  };

  render() {
    const { maxPeople = 4 } = this.props;
    const { team, isCaptain, inviteCode, loading, joinLoading } = this.state;

    // 已创建/加入队伍：展示队伍卡片
    if (team) {
      return (
        <div className={styles['team-card']}>
          <div className={styles['team-card-title']}>
            <CrownOutlined /> 我的队伍
            <span className={styles['team-count']}>
              {team.users.length}/{maxPeople} 人
            </span>
          </div>
          <div className={styles['invite-row']}>
            <span className={styles['invite-label']}>专属邀请码</span>
            <span className={styles['invite-code']}>{team.inviteCode}</span>
            <Button
              size="small"
              type="primary"
              ghost
              icon={<CopyOutlined />}
              onClick={this.copyInvite}
            >
              复制
            </Button>
          </div>
          <div className={styles['member-list']}>
            {team.users.map((u) => (
              <div key={u.user._id} className={styles['member-item']}>
                <UserOutlined />
                <span className={styles['member-name']}>
                  {u.user.name}（{u.user.staffId}）
                </span>
                {u.isCaptain ? (
                  <Tag color="gold" className={styles['captain-tag']}>
                    队长
                  </Tag>
                ) : null}
              </div>
            ))}
          </div>
          {isCaptain ? (
            <div className={styles['team-tip']}>
              把邀请码分享给同学，他们输入邀请码即可加入队伍
            </div>
          ) : (
            <div className={styles['team-tip']}>
              已通过邀请码加入队伍，等待队长组织报名
            </div>
          )}
        </div>
      );
    }

    // 未报名：创建队伍 / 输入邀请码加入
    return (
      <div className={styles['team-actions']}>
        <Button
          type="primary"
          block
          loading={loading}
          onClick={this.createTeam}
          className={styles['create-btn']}
        >
          创建队伍
        </Button>
        <div className={styles['divider']}>或</div>
        <div className={styles['join-row']}>
          <Input
            placeholder="输入邀请码加入队伍"
            value={inviteCode}
            maxLength={10}
            onChange={(e) => this.setState({ inviteCode: e.target.value })}
            onPressEnter={this.joinTeam}
            allowClear
          />
          <Button
            loading={joinLoading}
            onClick={this.joinTeam}
            className={styles['join-btn']}
          >
            加入
          </Button>
        </div>
        <div className={styles['join-tip']}>
          每支队伍最多 {maxPeople} 人，队长创建后生成专属邀请码
        </div>
      </div>
    );
  }
}